<template>
  <b-modal
    :id="`modal-alert-rule-branch-edit-${branchData.branchId}`"
    :title="`Editar Regra de Filial ${branchData.name}`"
    size="xl"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @ok="editRule"
  >
    <edit-rule-component :branchRuleId="branchData.rule" />
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';
import api from '../../../services/api';
import editRuleComponent from '../../organisms/settings/settings-alert-rules/edit-rule/tab-geral-edit';

export default {
  props: ['ruleId', 'branchData', 'page', 'filter'],
  components: {
    editRuleComponent,
  },

  data: () => ({
    userAuth: null,
    limit: 10,
  }),

  computed: {
    ...mapState('alertRules', ['myRule']),
    ...mapFields('alertRules', ['branchItems']),
  },

  methods: {
    ...mapActions('alertRules', ['getBranchRules']),

    async editRule() {
      try {
        await api.put(
          `${process.env.API_ROOT}/branch-alert-rule/${this.userAuth.companyId}/${this.myRule._id}`,
          { ...this.myRule },
          {
            headers: { 'x-access-token': this.userAuth.token },
          },
        );

        await this.getBranchRules({
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          mainRuleId: this.myRule.mainRuleId,
          params: {
            limit: this.limit,
            page: this.page,
            filter: this.filter,
          },
        });

        await swal(
          'Sucesso!',
          `A Regra para a filial ${this.branchData.name} foi editada!`,
          'success',
        );
      } catch (error) {
        swal('Erro', `Algo deu errado!`, 'Warning');
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/modal-alert-rule-branch-edit/index.vue